<script>
const columns = [
  {
    title: "Nombre motivo",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Total quejas",
    dataIndex: "count",
    scopedSlots: { customRender: "count" },
  },
];

export default {
  name: "TableWithCountField",
  props: {
    soloPreview: {
      type: Boolean,
      default: false,
    },
    totalCounterModel: {
      type: Number,
      default: -1,
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectedItemsIds: {
      type: Array,
      default: () => [],
    },
    selectedItemsDetail: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    columns: columns,
    localOptions: [],
    searchTerm: "",
  }),
  watch: {
    options: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.localOptions = newVal;
        }
      },
      immediate: true,
    },
    selectedItemsIds: {
      handler(newVal) {
        if (!Array.isArray(newVal)) {
          this.$emit('update-items', [], this.selectedItemsDetail || []);
        }
      },
      deep: true,
    },
  },
  created() {
    this.localOptions = Array.isArray(this.options) ? this.options : [];
  },
  methods: {
    isRowSelected(key) {
      if (!Array.isArray(this.selectedItemsIds)) return false;
      const normalizedKey = String(key);
      return this.selectedItemsIds.some(id => String(id) === normalizedKey);
    },
    valueCount(id) {
      if (!Array.isArray(this.selectedItemsDetail)) return null;
      const item = this.selectedItemsDetail.find(
        (element) => String(element.id) === String(id)
      );

      if (item) {
        return item.count;
      }
      return null;
    },
    updateDetail(key, value) {
      if (!Array.isArray(this.selectedItemsDetail)) {
        this.selectedItemsDetail = [];
      }
      
      const detailIndex = this.selectedItemsDetail.findIndex(
        (detail) => String(detail.id) === String(key)
      );
      if (detailIndex >= 0) {
        this.selectedItemsDetail[detailIndex].count = value;
      } else {
        this.selectedItemsDetail.push({ id: key, count: value });
      }
      this.$emit(
        "update-items",
        this.selectedItemsIds || [],
        this.selectedItemsDetail
      );
    },
    clearSearch() {
      this.searchTerm = "";
    },
    normalizeIds(ids) {
      if (!Array.isArray(ids)) return [];
      return ids.map(id => {
        const sampleId = this.localOptions.length > 0 ? this.localOptions[0].id : null;
        if (sampleId !== null && typeof sampleId === 'number') {
          const numId = Number(id);
          return isNaN(numId) ? id : numId;
        }
        return String(id);
      });
    },
  },

  computed: {
    filteredOptions() {
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        return this.localOptions;
      }
      const searchLower = this.searchTerm.toLowerCase().trim();
      return this.localOptions.filter(item => {
        const name = item.name || '';
        return name.toLowerCase().includes(searchLower);
      });
    },
    totalItems() {
      if (!Array.isArray(this.selectedItemsDetail)) return 0;
      return this.selectedItemsDetail.reduce((sum, item) => {
        return sum + Number(item.count || 0);
      }, 0);
    },
    normalizedSelectedIds() {
      return this.normalizeIds(this.selectedItemsIds || []);
    },
    rowSelection() {
      return {
        selectedRowKeys: this.normalizedSelectedIds,
        onChange: (selectedRowKeys, selectedRows) => {
          // Obtener los IDs de las filas seleccionadas que están visibles (en el filtro actual)
          const visibleSelectedIds = [];
          
          if (selectedRows && selectedRows.length > 0) {
            // Si tenemos selectedRows, usar sus IDs directamente
            visibleSelectedIds.push(...selectedRows.map(row => row.id));
          } else if (selectedRowKeys && selectedRowKeys.length > 0) {
            // Si no tenemos selectedRows, buscar en filteredOptions
            selectedRowKeys.forEach(key => {
              const found = this.filteredOptions.find(opt => {
                return String(opt.id) === String(key) || opt.id === key;
              });
              if (found) {
                visibleSelectedIds.push(found.id);
              }
            });
          }

          // Normalizar los IDs visibles
          const normalizedVisibleIds = this.normalizeIds(visibleSelectedIds);
          
          // Obtener las selecciones previas (todas, incluyendo las que no están visibles)
          const previousSelectedIds = this.normalizedSelectedIds;
          
          // Obtener los IDs de las opciones que están visibles en el filtro actual
          const visibleOptionIds = this.filteredOptions.map(opt => {
            const sampleId = this.localOptions.length > 0 ? this.localOptions[0].id : null;
            if (sampleId !== null && typeof sampleId === 'number') {
              return Number(opt.id);
            }
            return String(opt.id);
          });
          
          // Combinar: mantener las selecciones previas que NO están visibles + las nuevas selecciones visibles
          const newSelectedIds = [
            // Mantener las selecciones previas que no están en el filtro actual (no visibles)
            ...previousSelectedIds.filter(id => {
              const isVisible = visibleOptionIds.some(visibleId => 
                String(visibleId) === String(id) || visibleId === id
              );
              return !isVisible; // Mantener solo las que NO están visibles
            }),
            // Agregar las nuevas selecciones que están visibles
            ...normalizedVisibleIds
          ];
          
          // Eliminar duplicados
          const uniqueSelectedIds = [...new Set(newSelectedIds.map(id => String(id)))].map(id => {
            const sampleId = this.localOptions.length > 0 ? this.localOptions[0].id : null;
            if (sampleId !== null && typeof sampleId === 'number') {
              const numId = Number(id);
              return isNaN(numId) ? id : numId;
            }
            return id;
          });

          // Mantener los detalles de TODOS los elementos seleccionados (visibles y no visibles)
          const newSelectedItemsDetail = [];

          uniqueSelectedIds.forEach((id) => {
            const option = this.localOptions.find(opt => {
              return String(opt.id) === String(id) || opt.id === id;
            });
            if (option) {
              // Buscar el detalle existente
              const existingDetail = Array.isArray(this.selectedItemsDetail) 
                ? this.selectedItemsDetail.find(
                    (detail) => String(detail.id) === String(id) || detail.id === id
                  )
                : null;
              
              // Si no existe detalle, crear uno nuevo solo si está en las selecciones visibles
              // Si ya existía, mantenerlo aunque no esté visible
              if (existingDetail || normalizedVisibleIds.some(visibleId => String(visibleId) === String(id))) {
                newSelectedItemsDetail.push({
                  id: id,
                  name: option.name,
                  count: existingDetail?.count ?? null,
                });
              }
            }
          });

          // Emitir el evento con los nuevos valores
          this.$emit(
            "update-items",
            uniqueSelectedIds,
            newSelectedItemsDetail
          );
        },
        getCheckboxProps: (record) => {
          const isSelected = this.normalizedSelectedIds.some(id => {
            return String(id) === String(record.id) || id === record.id;
          });
          return {
            props: {
              disabled: this.soloPreview,
              name: record.name,
              defaultChecked: isSelected,
            },
          };
        },
      };
    },
  },
};
</script>

<template>
  <div class="w-full">
    <div class="w-100 mb-6">
      <a-collapse class="mt-6 text-left">
        <a-collapse-panel
          key="1"
          :header="`Motivos (${normalizedSelectedIds.length} motivos seleccionados)`"
        >
          <p
            slot="extra"
            class="text-opacity-80"
            :class="
              totalCounterModel != totalItems
                ? 'text-red-500'
                : 'text-green-500'
            "
          >
            Total: {{ totalItems }}
            {{
              totalCounterModel != totalItems
                ? " (El valor no coincide con el reportado)"
                : ""
            }}
          </p>
          
          <!-- Campo de búsqueda -->
          <div style="position: relative; margin-bottom: 16px;" @click.stop>
            <input
              type="text"
              v-model="searchTerm"
              placeholder="Buscar..."
              style="width: 100%; padding: 8px 40px 8px 16px; border-radius: 8px; border: 1px solid #d1d5db; font-size: 14px; outline: none;"
              @click.stop
            />
            <button
              v-if="searchTerm"
              @click.stop="clearSearch"
              style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; border: none; background: transparent; cursor: pointer; border-radius: 4px;"
              type="button"
            >
              <svg style="width: 16px; height: 16px; color: #6b7280;" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>

          <a-table
            size="small"
            :pagination="false"
            :row-selection="rowSelection"
            :columns="columns"
            :data-source="filteredOptions"
            row-key="id"
          >
            <template slot="name" slot-scope="text, record">
              <a class="flex text-left">{{ text }}</a>
            </template>
            <template class="p-0" slot="count" slot-scope="text, record">
              <BaseNumber
                v-if="isRowSelected(record.id)"
                :disabled="soloPreview"
                :value="valueCount(record.id)"
                @notify-change="updateDetail(record.id, $event)"
                label="Digita una cantidad"
                ref="num_31_numero_total_solicitudes"
                class="col-start-1 col-span-2 mt-0 pt-0"
                placeholder="Ej: 123"
                :mt_disabled="true"
                :validatePositiveInteger="true"
              />
            </template>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>